import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    meta: { requiresAuthentication: false },
    name: "Home",
    component: () => import("@/views/authentication/Login")
  },
  {
    path: "/printer",
    redirect: "connect/printer",
    name: "printer",
    component: () => import("@/layouts/full-layout/ConnectLayout"),
    meta: { requiresAuthentication: true },
    children: [
      {
        name: "OldPrinter",
        path: "printer",
        component: () => import("@/views/printer/Printer")
      },
      {
        name: "OldPrinterSettings",
        path: "printersettings",
        component: () => import("@/views/printer/PrinterSettings")
      }
    ]
  },
  {
    path: "/connect",
    redirect: "connect/printer",
    name: "connect",
    component: () => import("@/layouts/full-layout/ConnectLayout"),
    meta: { requiresAuthentication: true },
    children: [
      {
        name: "Printer",
        path: "printer",
        component: () => import("@/views/printer/Printer")
      },
      {
        name: "PrinterSettings",
        path: "printersettings",
        component: () => import("@/views/printer/PrinterSettings")
      },
      {
        name: "Office",
        path: "office",
        component: () => import("@/views/office/Office")
      },
      {
        name: "OfficeSettings",
        path: "officesettings",
        component: () => import("@/views/office/OfficeSettings")
      }
    ]
  },
  {
    path: "/document-receiver",
    redirect: "connect/document-receiver",
    component: () => import("@/layouts/full-layout/LayoutWithoutDrawer"),
    meta: { requiresAuthentication: true },
    children: [
      {
        path: "/connect/document-receiver",
        name: "DocumentReceiver",
        component: () => import("@/views/complement/DocumentReceiver"),
        meta: { requiresAuthentication: true }
      }
    ]
  },
  {
    path: "/",
    redirect: "/apps",
    component: () => import("@/layouts/full-layout/Layout"),
    meta: { requiresAuthentication: true },
    children: [
      // Application
      {
        name: "Apps",
        path: "apps",
        component: () => import("@/views/apps/Apps"),
        props: true
      },
      {
        name: "DigitalSignature",
        path: "tools/digital-signature",
        props: true,
        component: () => import("@/views/tools/DigitalSignature")
      },
      {
        name: "DocumentsValidate",
        path: "tools/document-validation",
        props: true,
        component: () => import("@/views/tools/DocumentsValidate")
      },
      {
        name: "TimestampSignature",
        path: "tools/timestamp-signature",
        props: true,
        component: () => import("@/views/tools/TimestampSignature")
      },
      {
        name: "RemoteSignaturesSent",
        path: "signatures/remote/sent",
        props: true,
        component: () => import("@/views/signatures/remote/HistoricSignatures")
      },
      {
        name: "RemoteSignaturesReceived",
        path: "signatures/remote/received",
        props: true,
        component: () => import("@/views/signatures/remote/RequestsReceived")
      },
      {
        name: "RemoteFlows",
        path: "signatures/remote/flows",
        props: true,
        component: () => import("@/views/signatures/remote/RemoteFlows")
      },
      {
        name: "FaceToFaceFlows",
        path: "signatures/face-to-face/flows",
        props: true,
        component: () => import("@/views/signatures/remote/RemoteFlows")
      },
      {
        name: "HistoricCertifiedNotifications",
        path: "signatures/certified-notifications/sent",
        props: true,
        component: () =>
          import(
            "@/views/signatures/certified-notifications/HistoricCertifiedNotifications"
          )
      },

      {
        name: "Templates",
        path: "signatures/remote/templates",
        component: () => import("@/views/templates/Templates")
      },
      {
        name: "FaceToFaceTemplates",
        path: "signatures/face-to-face/templates",
        component: () => import("@/views/templates/Templates")
      },
      {
        name: "CorrespondenceCombination",
        path: "signatures/remote/correspondence-combination",
        props: true,
        component: () =>
          import("@/views/signatures/remote/CorrespondenceCombination")
      },
      {
        name: "BulkDownload",
        path: "signatures/remote/bulk-download",
        props: true,
        component: () => import("@/views/signatures/remote/BulkDownload")
      },
      {
        name: "Contactacs",
        path: "signatures/remote/contacts",
        props: true,
        component: () => import("@/views/signatures/remote/Contacts")
      },
      {
        name: "RemoteSignaturesMultipleAccept",
        path: "signatures/remote/multi-accept",
        props: true,
        component: () =>
          import("@/views/signatures/remote/RemoteSignaturesMultiAccept")
      },
      {
        name: "RemoteSettings",
        path: "signatures/remote/settings",
        props: true,
        component: () => import("@/views/settings/Settings")
      },
      {
        name: "FaceToFaceSettings",
        path: "signatures/face-to-face/settings",
        props: true,
        component: () => import("@/views/settings/Settings")
      },
      {
        name: "CertifiedNotificationsSettings",
        path: "signatures/certified-notifications/settings",
        props: true,
        component: () => import("@/views/settings/Settings")
      },
      {
        name: "FaceToFaceSignatures",
        path: "signatures/face-to-face/sent",
        props: true,
        component: () =>
          import("@/views/signatures/face-to-face/FaceToFaceSignatures")
      },
      {
        name: "FaceToFaceDevices",
        path: "signatures/face-to-face/devices",
        props: true,
        component: () =>
          import("@/views/signatures/face-to-face/DeviceFaceToFaceSignatures")
      },
      {
        name: "Profile",
        path: "profile",
        component: () => import("@/views/profile/Profile")
      },
      {
        name: "Customer",
        path: "my-subscription/my-company",
        component: () => import("@/views/customer/Customer")
      },
      {
        name: "CustomerStatistics",
        path: "my-subscription/statistics",
        component: () => import("@/views/customer/Statistics")
      },
      {
        name: "CustomerTeams",
        path: "my-subscription/teams",
        component: () => import("@/views/customer/Teams")
      },
      {
        name: "CustomerUsers",
        path: "my-subscription/users",
        component: () => import("@/views/customer/Users")
      },
      {
        name: "PaymentMethods",
        path: "profile/payment-methods",
        component: () => import("@/views/profile/PaymentMethods")
      },
      // Purchase
      {
        name: "Purchase",
        path: "purchase",
        component: () => import("@/views/purchase/AvailablePlans")
      },
      {
        name: "Checkout",
        path: "purchase/checkout",
        component: () => import("@/views/purchase/Checkout")
      },
      {
        name: "Purchase-Success",
        path: "purchase/success",
        component: () => import("@/views/purchase/Success")
      }
    ]
  },
  {
    name: "NewDocumentSet",
    path: "/signatures/remote/new-multi",
    component: () => import("@/views/signatures/remote/NewDocumentSet"),
    meta: { requiresAuthentication: true },
    props: true
  },
  {
    name: "NewFaceToFaceSignature",
    path: "/signatures/face-to-face/new",
    component: () =>
      import("@/views/signatures/face-to-face/NewFaceToFaceSignature"),
    meta: { requiresAuthentication: true },
    props: true
  },
  {
    name: "FormEditor",
    path: "/form-editor",
    component: () => import("@/views/formEditor/Wysiwyg"),
    props: true
  },
  { path: "*", redirect: "/apps" }
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
  // base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  }
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.beforeEach(async (to, from, next) => {
  window.toasted.clear();
  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    await router.app.$auth.ensureAuthenticated(to);
    next();
  } else {
    next();
  }
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
